import { Typography } from "@mui/material";
import styled from "styled-components";

export const CaseStudyStatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  max-width: 1170px;
  min-height: 125px;

  border-radius: 16px;
  padding: 12.5px 0;
  gap: 10px;
  margin: 120px auto;

  background-color: ${(props) => props?.theme.colors.secondaryOpaque};
  @media (max-width: 600px) {
    margin: 32px 50px;
    flex-direction: column;
    height: auto;

    gap: 32px;
    padding: 24px 0;
  }
`;

export const CaseStudyStatContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 190px;
  min-height: 100px;

  gap: 12px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    height: auto;
    max-width: 180px;
  }
`;

export const NumberStyled = styled(Typography)`
  font-weight: 700;
  font-size: 42.37px;
  line-height: 100%;

  letter-spacing: -1.18px;
  text-align: center;
  color: ${(props) => props?.theme.colors?.white};
  vertical-align: middle;

  @media (max-width: 600px) {
    font-size: 27px;
  }
`;

export const TextStyled = styled(Typography)`
  font-weight: 500;
  font-size: 23.37px;
  line-height: 100%;
  text-align: center;
  color: ${(props) => props?.theme.colors?.white};
  font-family: "Mona-Sans";
  white-space: pre-line;

  @media (max-width: 600px) {
    font-size: 15px;
  }
`;
